module.exports = __webpack_public_path__ + "img/file-user-line.629f8e82.svg";